export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_RESET = "FORGET_PASSWORD_RESET"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"
